import React, { useEffect, useState } from 'react';

export default function BrandsListContainer(props) {
    const { brands, availableCategories } = props;
    const [brandItems, setBrandItems] = useState(brands);
    const [selectedCategory, setSelectedCategory] = useState('');

    const setVisibleBrands = (category) => {
        setSelectedCategory(category);
        let itemToSet = category != '' ? brands.filter(x => x.SelectedCategories.includes(category)) : brands;
        setBrandItems(itemToSet);
    };

    return (
        <>
            {availableCategories && availableCategories.length > 0 &&
                <ul className="brands-list__button-container columns">
                    <li onClick={() => setVisibleBrands('')} className={selectedCategory == '' && 'selected'}>Visa alla</li>
                    {availableCategories.map((category) =>
                        <li className={selectedCategory == category && 'selected'} onClick={() => setVisibleBrands(category)}>{category}</li>
                    )}
                </ul>
            }
            {brandItems && brandItems.length > 0 &&
                <ul className="brands-list">
                    {brandItems.map((brand) =>
                        <li className="brands-list__brand-container large-3 medium-4 small-12 column">
                            <div className="brands-list__brand columns">
                                <a href={brand.Url}>
                                    <div className="brands-list__brand-image-wrapper">
                                        <img src={brand.ImageUrl} className="brands-list__brand-image" />
                                    </div>
                                    <h6 className="brands-list__brand-name">{brand.Name}</h6>
                                    <p className="brands-list__brand-title">{brand.Title}</p>
                                </a>
                                {brand.Categorys && brand.Categorys.length > 0 &&
                                    <ul className="brands-list__brand-categories">
                                        {brand.Categorys.map((category) =>
                                            <li className="brands-list__brand-category">
                                                <a href={category.Url}>{category.Name}</a>
                                            </li>
                                        )}
                                    </ul>
                                }
                            </div>
                        </li>
                    )}
                </ul>
            }
        </>
    );
}
